import React from 'react'
import Img from './code.png';
import Typewriter from 'typewriter-effect';
import {Helmet} from 'react-helmet';


export default function QRCODE() {
  return (
    <div>
<Helmet>
  <meta charSet="utf-8" />
  <title>Share Nabeel-R</title>
  <link rel="canonical" href="http://nabeel-r.netlify.app/qr" />
  <meta name="description" content="Nabeel-R: QRCode to share my Website. My expertise is in technology. I am passionate about technology. I am proficient in ML, Web Dev, Coding, Data Science." />
</Helmet>
      

<br/>    <br/>
<center>
<h1 className='title'><span className='white'><span className='lettercolor'>Q</span>RCode</span></h1>
</center>
<br/><br/><br/><br/>

<center>
<h1><img className='contain' height={300} width={300} src={Img}/></h1>
</center>

<br/><br/>

<div className='code'>
<center>
<div className='white article'>
<Typewriter 
  onInit={(typewriter) => {
    typewriter.typeString(

   "To Share the Website<br/><br/>Scan the QRCODE"
      
    )
      .pauseFor(250)
      .start();
  }}
/>
</div>

</center>
</div>

<br/><br/><br/><br/><br/><br/>

    </div>
  )
}
